<mat-dialog-content>
<div class="login-form-container">
    <div class="logo-img-container"><img src="assets/img/AP7_CX-BM-RGB.png" alt="BIMSWARM Logo" class="logo-img"></div>
    <div class="login-form-content">
        <h1>Bei BIMSWARM anmelden</h1>
        <mat-error *ngIf="errorLogin" class="error-login">
            <div class="alert-icon"></div>Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.
        </mat-error>
        <form [formGroup]="loginForm" (ngSubmit)="onLogin()" (keydown.enter)="$event.preventDefault()">
            <div class="login-fields-container">
                <mat-form-field>
                    <mat-label>E-Mail-Adresse</mat-label>
                    <input type="email" matInput formControlName="email" required>
                    <button *ngIf="loginForm.get('email')?.value" matSuffix mat-icon-button class="clear-btn"
                        aria-label="Clear" (click)="clearValue('email')">
                        <mat-icon>close</mat-icon>
                    </button>
                    <mat-error *ngIf="
                            (loginForm.get('email')?.hasError('email') || loginForm.get('email')?.hasError('pattern')) &&
                            !loginForm.get('email')?.hasError('required')
                        ">Bitte geben Sie eine valide E-Mail an</mat-error>
                    <mat-error *ngIf="loginForm.get('email')?.hasError('required')">Diese Angabe ist
                        erforderlich</mat-error>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Passwort</mat-label>
                    <input [type]="showPassword ? 'text' : 'password'" matInput formControlName="password" required>
                    <button class="visibility-btn" matSuffix (click)="showPassword = !showPassword"
                        [attr.aria-label]="'Passwort anzeigen/verbergen'" [attr.aria-pressed]="showPassword"
                        type="button">
                        <div class="visibility-icon" [class]="showPassword? 'visibility_off' : 'visibility'"></div>
                    </button>
                    <mat-error *ngIf="loginForm.get('password')?.hasError('required')">Diese Angabe ist
                        erforderlich</mat-error>
                    <mat-error
                        *ngIf="loginForm.get('password')?.hasError('minlength') && !loginForm.get('password')?.hasError('required')">
                        Das Passwort muss mindestens 6 Zeichen lang sein
                    </mat-error>
                </mat-form-field>
                <p>Passwort vergessen? <a mat-dialog-close [routerLink]="['/resetPassword']">Hier zurücksetzen</a></p>
            </div>

            <div class="submit-btn-container" mat-dialog-actions>
                <!-- [disabled]="!loginForm.valid" ??? -->
                <button matButton="elevated" class="green-confirm submit-btn" type="submit">Anmelden</button>
                <p>Sie haben noch kein Account? <a mat-dialog-close (click)="goToRegister()"
                        [routerLink]="['/registry']">Registrieren</a></p>
            </div>
        </form>
    </div>
</div>
<button class="close-btn" mat-icon-button mat-dialog-close>
    <mat-icon aria-label="Close icon">close</mat-icon>
</button>
</mat-dialog-content>

<div *ngIf="loading" class="loading-overlay-spinner">
    <mat-spinner></mat-spinner>
</div>
